<template>
  <div class="switch-view-buttons">
    <div
      class="icon-button"
      :class="{ active: typeView === 'cards' }"
      @click="switchView"
    >
      <img class="icon-button__icon" :src="cardsIcon" alt="" />
    </div>
    <div
      class="icon-button"
      :class="{ active: typeView === 'table' }"
      @click="switchView"
    >
      <img class="icon-button__icon" :src="tableIcon" alt="" />
    </div>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import CardsIcon from './assets/cards.svg';
  import TableIcon from './assets/table.svg';

  const props = defineProps({
    typeView: {
      type: String,
      default: 'cards',
      validator: (value) => ['cards', 'table'].includes(value),
    },
  });

  const emit = defineEmits(['update:typeView']);

  const typeView = ref(props.typeView);
  const cardsIcon = computed(() => {
    return CardsIcon;
  });
  const tableIcon = computed(() => {
    return TableIcon;
  });

  const switchView = () => {
    typeView.value = typeView.value === 'cards' ? 'table' : 'cards';
    emit('update:typeView', typeView.value);
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .switch-view-buttons {
    display: flex;
    gap: 10px;
  }

  .icon-button {
    height: 32px;
    width: 32px;
    padding: 2px;
    border-radius: 2px;
    border: 2px solid $color-bg-primary-white;
    background-color: $color-bg-primary-white;

    .icon-button__icon {
      width: 24px;
      height: 24px;
      flex: 0 0 24px;

      &:hover,
      &:focus {
        filter: invert(75%) sepia(24%) saturate(4159%) hue-rotate(44deg)
          brightness(100%) contrast(77%);
      }
    }

    &:hover,
    &:focus {
      border-color: $color-bg-secondary-grey;
      background-color: $color-bg-secondary-grey;
    }

    &:active {
      border-color: $color-btn-primary-active;
      background-color: $color-bg-secondary-grey;
    }

    &.active {
      .icon-button__icon {
        filter: invert(75%) sepia(24%) saturate(4159%) hue-rotate(44deg)
          brightness(100%) contrast(77%);
      }
    }
  }
</style>
